module.exports = __webpack_public_path__ + "mobile/img/img5-618.bea54560.png";